<template>
  <div class="lost">
    <div class="hearder">
      <van-icon class="head-icon" name="revoke" @click="back(-1)" />
      <span class="head-close" @click="$router.push('/')">关闭</span>
      <span>公告详情</span>
      <!-- 图片广告 -->
    </div>
    <div style="padding:10px;display: flex;flex-direction: column;align-items: center;">
      <div style="margin-bottom: 10px;font-weight:600;color:#303133;font-size:15px;">
          {{ contents.Title }}
      </div>
      <div style="margin-bottom: 15px;">
        {{contents.Text}}
      </div>
      <div v-for="(item,index) in contents.content "
           :key="index">
        <van-image fit="contain"
                   :src="item.PicURL" v-if="item.Tags.indexOf('image')!=-1" @click="imagePreviewClick(item.PicURL)"  />
        <video width="100%"
               :src="item.PicURL"
               v-if="item.Tags.indexOf('video')!=-1"
               controls />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { GetAllLostInfo } from '../../api/Nearbybusline'
import { Toast, ImagePreview } from 'vant'
export default {
  inject: ['reload'],
  data() {
    return {
      showFooter: true,
      isLoading: false,
      contents: '',
    }
  },
  methods: {
    back(path) {
      this.$router.go(path)
    },
    getStatic() {
      axios.get(`https://www.zjgjapp.top:2000/com/6/GetITNotice?session=D5782FE5DBF8405C877FA54CA54D9DCB&id=${this.$route.params.id}`).then(res=>{
          this.contents = res.data
      })
    //   http://192.168.2.106:2027/com/7/GetITNotice?session=D5782FE5DBF8405C877FA54CA54D9DCB&id=1079
      //   axios.get(`http://192.168.2.106:2027/com/7/GetAllLostInfo?session=D5782FE5DBF8405C877FA54CA54D9DCB&id=${this.$route.params.id}`).then(res=>{
      //       this.contents = res.data
      //   })
    },
    //下拉刷新
    onRefresh() {
      setTimeout(() => {
        Toast('刷新成功')
        this.reload()
        this.isLoading = false
      }, 1000)
    },

    // 图片预览
    imagePreviewClick(row) {
        ImagePreview([row])
    }
  },
  mounted() {
    this.getStatic()
  },
}
</script>

<style scoped lang="scss">
.lost {
  .hearder {
  width: 100%;
  height: 50px;
  background-image: linear-gradient(to right, #1c88e0, rgb(9, 71, 158));
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.hearder span {
  font-size: 15px;
}
.hearder .head-close {
  position: absolute;
  left: 10%;
  font-size: 15px;
}
.hearder .head-icon {
  position: absolute;
  left: 4%;
  font-size: 15px;
//   font-size: 13px;
}
  main {
    .box {
      width: 100%;
      padding: 10px;
      p {
        color: #555;
        margin-bottom: 10px;
      }
      a {
        color: #000;
      }
    }
    .box .search {
      width: 100%;
      padding: 6px;
      .inpWrap {
        width: 100%;
        background-color: rgb(226, 226, 226);
        border-radius: 6px;
        .icon-suosou {
          color: #ccc;
          margin: 0 10px;
        }
        input {
          width: 80%;
          height: 36px;
          border: 0;
          outline: none;
          background-color: rgb(226, 226, 226);
          padding: 4px;
        }
      }
    }
  }
}
li {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
li span:nth-child(2) {
  color: red;
}
</style>